import msg, {get_msg_txt} from "../../../../consts/msg";
import getYesNoLabel from "./getYesNoLabel";

const getIsPersonalInfoText = ({lang, is_personal_info}) => {
    return `${get_msg_txt(lang, msg.confirm_is_personal_info)} : ${getYesNoLabel({lang, value: is_personal_info})}`
};

export default getIsPersonalInfoText;